export enum PartnerStatus {
  Active = 'active',
  Deleted = 'deleted',
}
